module.exports = __webpack_public_path__ + "static/other/collage.29e0ba4f.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/collage.json
// module id = 2262
// module chunks = 0